import { render } from "./ResultsPanel.vue?vue&type=template&id=2cb9dd17&scoped=true"
import script from "./ResultsPanel.vue?vue&type=script&lang=js"
export * from "./ResultsPanel.vue?vue&type=script&lang=js"

import "./ResultsPanel.vue?vue&type=style&index=0&id=2cb9dd17&scoped=true&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb9dd17"]])

export default __exports__